import Vue from "vue";

Vue.prototype.$handleError = (error) => {
    console.log(error);
    alert(error.response ? error.response.data.message : error.message);
};
